import ProductIndividual from "./ProductIndividual";

const Product = ({ products }) => {
  return (
    <div>
      {products.map((product) => (
        <ProductIndividual key={Math.random()} data={product} />
      ))}
    </div>
  );
};

export default Product;
